import { render, staticRenderFns } from "./MasterComponent.vue?vue&type=template&id=839683c2&scoped=true&"
import script from "./MasterComponent.vue?vue&type=script&lang=js&"
export * from "./MasterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839683c2",
  null
  
)

export default component.exports